module.exports = "/_next/static/festival-cc.fb2bb489c6bdbe831255355f980b757d.css";